module.exports = __webpack_public_path__ + "static/media/L (6).994fd8d3.jpg";